import { ServiceLocator } from '../../app/ServiceLocator';
import { L10n } from '../L10n/L10n';
import { FlowBasicInfo } from '../models/FlowInfo';
import { Module } from '../Module';
import { Flows } from '../resources/Flows';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { RunFlowOnOutputStepsNotification } from './RunFlowOnOutputStepsNotification';

export class RunFlowOnOutputStepsAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'Flows',
                           'RunFlowOnOutputStepsNotification'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private confirmActionDialog: ConfirmActionDialog,
    private flows: Flows,
    private runFlowOnOutputStepsNotification: RunFlowOnOutputStepsNotification) { }

  public showRunFlowOnOutputStepsDialog(
    flow: FlowBasicInfo,
    outputIds: string[],
    isIncremental: boolean): ng.IPromise<any> {

    const scope = ServiceLocator.getAngularActionContext().scope;

    let dialogBody: string;

    dialogBody = this.$translate.instant('runFlowsOnOutputStepsPrompt',
    { FLOW_NAME: L10n.elideIfLong(flow.name), ITEM_COUNT: outputIds.length }, L10n.Interpolations.Count);

    const dialogInstance = this.confirmActionDialog.open({
      scope: scope,
      title: this.$translate.instant('runNow'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('runNowConfirmButton'),
      action: () => this.flows.runFlowOnOutputSteps(flow.id, outputIds, isIncremental),
    });

    dialogInstance.result.then((result: IResult) => {
      this.runFlowOnOutputStepsNotification.notify(result, flow, outputIds.length);
    });

    return dialogInstance.result;
  }

}

Module.instance().service('RunFlowOnOutputStepsAction', RunFlowOnOutputStepsAction);
